<template>
  <div class="container login text-center">
    <div>
      <div class="movie-list-header mt-0">
        <h1>Please sign in</h1>
      </div>
      <LoginForm></LoginForm>
      <p v-if="accountCreationAllowed && hasInvite" class="text-white mt-3">
        New to Movie List?
        <router-link :to="{ name: 'Sign Up', query: redirectQuery }">Create an account</router-link>
      </p>
      <p v-else class="text-white mt-3">New to Movie List? Ask your group for an invite link.</p>
    </div>
  </div>
</template>

<script>
import LoginForm from "@/components/LoginForm.vue";
import { authComputed } from "../../store/helpers.js";
import { inviteTokenFromRedirect } from "@/utilities/invite";
import { accountCreationAllowed } from "@/config/accountCreation";

export default {
  name: "LoginView",
  components: {
    LoginForm,
  },
  computed: {
    ...authComputed,
    hasInvite() {
      return Boolean(inviteTokenFromRedirect(this.$route.query.redirect));
    },
    accountCreationAllowed() {
      return accountCreationAllowed;
    },
    redirectQuery() {
      return this.$route.query.redirect ? { redirect: this.$route.query.redirect } : {};
    },
  },
};
</script>

<style scoped>
.login {
  height: calc(100vh - 136px);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
